<template>
  <ankh-list :padding="0" v-bind="$attrs" :show-search-form="false">
    <template #btn-group>
      <el-button size="small" type="primary" @click="handleShowFormDialog()">{{$t('新增')}}</el-button>
      <el-button size="small" type="danger" @click="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #table="{height}">
      <table-list
          ref="list"
          @query="loadList"
          @selection-change="selection = $event"
          :data="tableData">
        <el-table-column type="selection" width="50" />
        <el-table-column type="index" :label="$t('序号')" width="50" />
        <el-table-column :label="$t('米水比')" prop="rwr" />
        <el-table-column :label="$t('硬度')" prop="hardness" />
        <el-table-column :label="$t('是否推荐')" prop="recommend">
          <template v-slot="{row}">
            {{row.recommend === "yes" ? $t('是') : $t('否')}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('小贴士')" prop="tips" />
        <el-table-column :label="$t('操作')">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link :underline="false" type="primary" @click="handleSwitchRecommend(row)">{{row.recommend === "yes" ? $t("取消推荐") : $t("推荐")}}</el-link>
              <el-link :underline="false" type="primary" @click="handleShowFormDialog(row)">{{$t('编辑')}}</el-link>
              <el-link :underline="false" type="danger" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

   <template #other>
     <rice-form
         @confirm="handleSubmitByAddOrEdit"
         :visible.sync="showDialog"
         :is-edit="isEdit"
         :data="currentRow" />
   </template>
  </ankh-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request, requestByTip} from "@/config/request";
import RiceForm from "@/components/rice/RiceForm";
import AnkhList from "@/components/list/AnkhList.vue";
export default {
  name: "RiceRatio",
  components: {AnkhList, RiceForm, TableList},
  data() {
    return {
      showDialog: false,
      tableData: [],
      selection: [],
      isEdit: false,
      currentRow: {}
    }
  },
  methods: {
    // 切换推荐
    async handleSwitchRecommend(row) {
      try {
        const params  = {
          code: row.code,
          recommend: row.recommend === "yes" ? "no" : "yes"
        }
        await request(this.$api.boiledRiceModel.updateStatus, params);
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    // 新增/编辑提交
    async handleSubmitByAddOrEdit(data) {
      try {
        const action = this.$api.boiledRiceModel[this.isEdit ? "update" : "add"];
        if(this.isEdit) {
          data = Object.assign(this.currentRow, data);
          delete data.createTime;
          delete data.updateTime;
        }
        await request(action, data);
        this.showDialog = false;
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    handleShowFormDialog(row) {
      if(row) {
        this.isEdit = true;
        this.currentRow = {...row};
      } else {
        this.isEdit = false;
      }
      this.showDialog = true;
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.boiledRiceModel.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      try {
        let codes = this.selection.map(item => item.code);
        if(!codes.length) {
          this.$message.warning(this.$t('请选择要删除的项'));
          return;
        }
        await requestByTip(
            this.$api.boiledRiceModel.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();

      } catch (e) {
        console.error(e);
      }
    },

    async loadList(params, setTotal) {
      try {
        const res = await request(this.$api.boiledRiceModel.list, params);
        this.tableData = res.boiledRiceModels;
        setTotal(res.pager.itemCount);
      } catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<style scoped>

</style>
